import Page, { IPage } from './Page';

export interface IPagePreview {
  id: string;
  title: string;
  body: string;
  imageUrl: string;
  pages?: Page[];
}

class PagePreview {
  public readonly id: string;
  public readonly title: string;
  public readonly body: string;
  public readonly imageUrl: string;
  public readonly pages?: Page[];

  constructor({
    id,
    title,
    body,
    imageUrl,
    pages,
  }: {
    id: string;
    title: string;
    body: string;
    imageUrl: string;
    pages?: Page[];
  }) {
    this.id = id;
    this.title = title;
    this.body = body;
    this.imageUrl = imageUrl;
    this.pages = pages;
  }

  public toJSON = () => ({
    id: this.id,
    title: this.title,
    body: this.body,
    imageUrl: this.imageUrl,
    pages: this.pages,
  });

  public static fromJSON = (json: IPagePreview): PagePreview => {
    const { id, title, body, imageUrl, pages } = Object.assign({}, json);

    if (typeof id !== 'string') throw new Error('.id must be a string');
    if (typeof title !== 'string') throw new Error('.title must be a string');
    if (typeof body !== 'string') throw new Error('.body must be a string');
    if (typeof imageUrl !== 'string') throw new Error('.imageUrl must be a string');

    const _pages = pages
      ? pages.map((comment: IPage) => {
          return Page.fromJSON(comment);
        })
      : undefined;

    return new PagePreview({
      id,
      title,
      body,
      imageUrl,
      pages: _pages,
    });
  };
}

export default PagePreview;
